module.exports = __webpack_public_path__ + "static/media/eiffel.a8e4aa84.jpeg";